import { useEffect, useState, useCallback } from 'react';
import '../components/pmndp-enhanced.css'; // Temporary fix for design breaking
import BookAnAppointment from '../components/Book-an-appointment';
import UnbookAppointment from '../components/Unbook-appointment';
import StartDialysis from '../components/Start-dialysis';
import CompleteDialysis from '../components/complete-dialysis';
import { pmndpAPI } from "../../../services/pmndp.api";
import { PMNDPTableSkeleton } from '../components/PMNDPLoader';
import {PeritonealDialysisModule} from "./PeritonealDialysisModule";
import { formatToApiDate } from "../../../helpers/common-helper";

const DIALYSIS_LABELS = {
    title: "Hemo Dialysis Module",
    abhaNumber: "ABHA Number:",
    abhaAddress: "ABHA Address :",
    healthId: "Health ID:",
    dialysisStatus: "Dialysis Status:",
    patientName: "Patient Name :",
    mobile: "Mobile :",
    selectStatus: "Select Status",
    progress: "Progress",
    scheduled: "Scheduled",
    complete: "Complete",
    failed: "Failed",
    search: "Search",
    reset: "Reset",
    sNo: "S.No.",
    age: "Age",
    gender: "Gender",
    mobileNo: "Mobile No.",
    abhaNumberCol: "ABHA number",
    abhaAddressCol: "ABHA Address",
    lastDialysis: "Last Dialysis",
    nextDialysis: "Next Dialysis",
    status: "Status",
    action: "Action",
    startDialysis: "Start Dialysis",
    completeDialysis: "Complete Dialysis",
    scheduleDialysis: "Schedule Dialysis",
    unbook: "Unbook",
    noData: "No data available.",
    first: "First",
    previous: "Previous",
    next: "Next",
    last: "Last",
    page: "Page",
    of: "of",
    na: "NA"
};

export const PatientsDialysisModules = () => {

    const [bookAnAppointmentModel, setBookAnAppointmentModel] = useState(false);
    const [startDialysis, setStartDialysis] = useState(false);
    const [completeDialysis, setCompleteDialysis] = useState(false);
    const [unbook, setUnbook] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(15); // You can make this dynamic if needed
    const [totalItems, setTotalItems] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [activeDialysisTab, setActiveDialysisTab] = useState("hemo");

    const [searchFields, setSearchFields] = useState({
        abhaNumber: "",
        abhaAddress: "",
        healthId: "",
        dialysisStatus: "",
        patientName: "",
        mobile: ""
    });

    const getDiaList = useCallback(async (pageNo = 1, search = searchFields) => {
        try {
            setIsLoading(true);
            // Pass page, pageSize, and search fields to backend API
            const resp = await pmndpAPI.getDialysisList({
                page: pageNo,
                pageLength: pageSize,
                abhaId: search.abhaNumber,
                abha_address: search.abhaAddress,
                healthIdNumber: search.healthId,
                status: search.dialysisStatus,
                name: search.patientName,
                mobile: search.mobile
            });
            const dialysislist = resp?.data?.data?.dataGet;
            const total = resp?.data?.data?.totalItems || 0;
            if (Array.isArray(dialysislist)) {
                setTableData(dialysislist);
            } else {
                console.warn('No dialysis data received or invalid format');
                setTableData([]);
            }
            setTotalItems(total);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching dialysis list:", error);
            setTableData([]);
            setIsLoading(false);
        }
    }, [pageSize, searchFields]);

    useEffect(() => {
        getDiaList(page, searchFields);
    }, [page, getDiaList, searchFields]);

    // Pagination controls
    const totalPages = Math.ceil(totalItems / pageSize);

    const handlePageChange = (newPage) => {
        if (newPage !== page) {
            setPage(newPage);
        }
    };

    // Handler for search input changes
    const handleSearchChange = (e) => {
        const { name, value } = e.target;
        setSearchFields(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handler for search button
    const handleSearch = () => {
        setPage(1);
        getDiaList(1, searchFields);
    };

    // Handler for reset button
    const handleReset = () => {
        const emptyFields = {
            abhaNumber: "",
            abhaAddress: "",
            healthId: "",
            dialysisStatus: "",
            patientName: "",
            mobile: ""
        };
        setSearchFields(emptyFields);
        setPage(1);
        getDiaList(1, emptyFields);
    };

    return (
        
       <div className="pmndp-enhanced-container">

    {/* 🔷 TOP SWITCH HEADER */}
    <div className="dialysis-switch-header">
      <button
        className={`dialysis-switch-btn ${
          activeDialysisTab === "hemo" ? "active" : ""
        }`}
        onClick={() => setActiveDialysisTab("hemo")}
      >
        <i className="fa fa-eye"></i> Hemo Dialysis
      </button>

       <button
        className={`dialysis-switch-btn ${
          activeDialysisTab === "peritoneal" ? "active" : ""
        }`}
        onClick={() => setActiveDialysisTab("peritoneal")}
      >
        <i className="fa fa-eye"></i> Peritoneal Dialysis
      </button> 
    </div>

    {activeDialysisTab === "hemo" ? (

      <div className="pmndp-card pmndp-fade-in">
                {/* Enhanced Header */}
                <div className="pmndp-header">
                    <div className="pmndp-header-content">
                        <div className="pmndp-header-left">
                            <div className="pmndp-icon">
                                <img src={"/images/PMNDP-logo.png"} alt="PMNDP" />
                            </div>
                            <h1 className="pmndp-title">{DIALYSIS_LABELS.title}</h1>
                        </div>
                    </div>
                </div>

                {/* Enhanced Filter Section */}
                <div className="pmndp-filter-section">
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', alignItems: 'end' }}>
                        <div className="pmndp-field" style={{ flex: '1 1 135px' }}>
                            <label>{DIALYSIS_LABELS.abhaNumber}</label>
                            <input
                                type="text"
                                placeholder={DIALYSIS_LABELS.abhaNumber.replace(':', '')}
                                name="abhaNumber"
                                value={searchFields.abhaNumber}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div className="pmndp-field" style={{ flex: '1 1 135px' }}>
                            <label>{DIALYSIS_LABELS.abhaAddress}</label>
                            <input
                                type="text"
                                placeholder={DIALYSIS_LABELS.abhaAddress.replace(' :', '')}
                                name="abhaAddress"
                                value={searchFields.abhaAddress}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div className="pmndp-field" style={{ flex: '1 1 135px' }}>
                            <label>{DIALYSIS_LABELS.healthId}</label>
                            <input
                                type="text"
                                placeholder={DIALYSIS_LABELS.healthId.replace(':', '')}
                                name="healthId"
                                value={searchFields.healthId}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div className="pmndp-field" style={{ flex: '1 1 135px' }}>
                            <label>{DIALYSIS_LABELS.dialysisStatus}</label>
                            <select
                                name="dialysisStatus"
                                value={searchFields.dialysisStatus}
                                onChange={handleSearchChange}
                            >
                                <option value="">{DIALYSIS_LABELS.selectStatus}</option>
                                <option value="4">{DIALYSIS_LABELS.progress}</option>
                                <option value="3">{DIALYSIS_LABELS.scheduled}</option>
                                <option value="1">{DIALYSIS_LABELS.complete}</option>
                                <option value="2">{DIALYSIS_LABELS.failed}</option>
                            </select>
                        </div>
                        <div className="pmndp-field" style={{ flex: '1 1 135px' }}>
                            <label>{DIALYSIS_LABELS.patientName}</label>
                            <input
                                type="text"
                                placeholder={DIALYSIS_LABELS.patientName.replace(' :', '')}
                                name="patientName"
                                value={searchFields.patientName}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div className="pmndp-field" style={{ flex: '0 0 135px' }}>
                            <label>{DIALYSIS_LABELS.mobile}</label>
                            <input
                                type="text"
                                placeholder={DIALYSIS_LABELS.mobile.replace(' :', '')}
                                name="mobile"
                                value={searchFields.mobile}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div style={{ display: 'flex', gap: '12px' }}>
                            <button className="pmndp-btn pmndp-btn-primary" type="button" onClick={handleSearch}>
                                <i className="fa fa-search"></i>
                                {DIALYSIS_LABELS.search}
                            </button>
                            <button className="pmndp-btn pmndp-btn-secondary" type="button" onClick={handleReset}>
                                <i className="fa fa-refresh"></i>
                                {DIALYSIS_LABELS.reset}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Enhanced Table */}
                <div className="pmndp-table-container" style={{ marginTop: "20px" }}>
                    {isLoading ? (
                        <PMNDPTableSkeleton rows={5} columns={11} />
                    ) : (
                        <div className="table-responsive">
                            <table className="pmndp-table">
                                <thead>
                                    <tr>
                                        <th>{DIALYSIS_LABELS.sNo}</th>
                                        <th>{DIALYSIS_LABELS.patientName.replace(' :', '')}</th>
                                        <th>{DIALYSIS_LABELS.age}</th>
                                        <th>{DIALYSIS_LABELS.gender}</th>
                                        <th>{DIALYSIS_LABELS.mobileNo}</th>
                                        <th>{DIALYSIS_LABELS.abhaNumberCol}</th>
                                        <th>{DIALYSIS_LABELS.abhaAddressCol}</th>
                                        <th style={{ width: '10%' }}>{DIALYSIS_LABELS.lastDialysis}</th> 
                                        <th style={{ width: '10%' }}>{DIALYSIS_LABELS.nextDialysis}</th>
                                        <th>{DIALYSIS_LABELS.status}</th>
                                        <th style={{ width: '13%' }}>{DIALYSIS_LABELS.action}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(tableData) && tableData.length > 0 ? (
                                        tableData.map((item, index) => {
                                            // Determine status class
                                            let statusClass = "";

                                            switch(item.dialysis_staus) {
                                                case 'Scheduled':
                                                    statusClass = "pmndp-status-scheduled";
                                                    break;
                                                case 'Progress':
                                                    statusClass = "pmndp-status-progress";
                                                    break;
                                                case 'Complete':
                                                    statusClass = "pmndp-status-complete";
                                                    break;
                                                case 'Failed':
                                                    statusClass = "pmndp-status-failed";
                                                    break;
                                                default:
                                                    statusClass = "pmndp-status-functional";
                                            }

                                            return (
                                                <tr key={item.id}>
                                                    <td>{(page - 1) * pageSize + index + 1}</td>
                                                    <td><strong>{item.patient_name}</strong></td>
                                                    <td>{item.age}</td>
                                                    <td>
                                                        <span className={`pmndp-status-badge ${item.gender === 'Male' ? 'pmndp-status-progress' : 'pmndp-status-scheduled'}`}>
                                                            {item.gender}
                                                        </span>
                                                    </td>
                                                    <td>{item.mobile}</td>
                                                    <td><code>{item.abha_number}</code></td>
                                                    <td>{item.abha_address ? item.abha_address : <span className="pmndp-status-badge pmndp-status-non-functional">{DIALYSIS_LABELS.na}</span>}</td>
                                                    <td>{formatToApiDate(item.last_dialysis) || <span className="pmndp-status-badge pmndp-status-non-functional">{DIALYSIS_LABELS.na}</span>}</td>
                                                    <td>{formatToApiDate(item.next_dialysis) || <span className="pmndp-status-badge pmndp-status-non-functional">{DIALYSIS_LABELS.na}</span>}</td>
                                                    <td>
                                                        <span className={`pmndp-status-badge ${statusClass}`}>
                                                            {item.dialysis_staus}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                                            {item.dialysis_staus === 'Scheduled' && (
                                                                <button
                                                                    onClick={() => setStartDialysis({
                                                                        patient_name: item.patient_name,
                                                                        patient_id: item.id,
                                                                        dialysis_id: item.dialysis_id,
                                                                        abha_number: item.abha_number,
                                                                        abha_address: item.abha_address,
                                                                        age: item.age,
                                                                        gender: item.gender,
                                                                        mobile: item.mobile
                                                                    })}
                                                                    className="pmndp-action-btn pmndp-action-btn-start"
                                                                    title="Start Dialysis"
                                                                >Start Dialysis</button>
                                                            )}

                                                            {item.dialysis_staus === 'Progress' && (
                                                                <button
                                                                    onClick={() => setCompleteDialysis({
                                                                        patient_name: item.patient_name,
                                                                        patient_id: item.id,
                                                                        last_dialysis: item.last_dialysis,
                                                                        dialysis_id: item.dialysis_id,
                                                                        abha_number: item.abha_number,
                                                                        abha_address: item.abha_address,
                                                                        age: item.age,
                                                                        gender: item.gender,
                                                                        mobile: item.mobile
                                                                    })}
                                                                    className="pmndp-action-btn pmndp-action-btn-complete"
                                                                    title="Complete Dialysis"
                                                                >Complete Dialysis
                                                                </button>
                                                            )}
                                                            

                                                            {(item.dialysis_staus === 'Fresh' || item.dialysis_staus === 'Complete' || item.dialysis_staus === 'Failed') && (

                                                                <button
                                                                    onClick={() => setBookAnAppointmentModel({
                                                                        patient_name: item.patient_name,
                                                                        patient_id: item.id,
                                                                        abha_number: item.abha_number
                                                                    })}
                                                                    className="pmndp-action-btn pmndp-action-btn-schedule"
                                                                    title="Schedule Dialysis"
                                                                >Schedule Dialysis</button>
                                                            )}

                                                            {item.showUnbookBtn && (
                                                                <button 
                                                                    onClick={() => setUnbook({
                                                                        patient_id: item.id,
                                                                        dialysis_id: item.dialysis_id,
                                                                        slot_id: item.slot_id
                                                                    })}
                                                                    className="pmndp-action-btn pmndp-action-btn-danger"
                                                                    title="Unbook Appointment"
                                                                >
                                                                    <i className="fa fa-times"></i>
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="11">
                                                <div className="pmndp-empty-state">
                                                    <div className="pmndp-empty-icon">
                                                        <i className="fa fa-user-md"></i>
                                                    </div>
                                                    <div className="pmndp-empty-title">{DIALYSIS_LABELS.noData}</div>
                                                    <div className="pmndp-empty-description">No patient data available for dialysis. Please check your search criteria or add new patients.</div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                    
                    {/* Enhanced Pagination */}
                    {totalPages > 1 && (
                        <div className="pmndp-pagination">
                            <button
                                className="pmndp-pagination-btn"
                                onClick={() => handlePageChange(1)}
                                disabled={page === 1 || isLoading}
                                title={DIALYSIS_LABELS.first}
                            >
                                &#171;
                            </button>
                            <button
                                className="pmndp-pagination-btn"
                                onClick={() => handlePageChange(page - 1)}
                                disabled={page === 1 || isLoading}
                                title={DIALYSIS_LABELS.previous}
                            >
                                &#8249;
                            </button>
                            
                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                .filter(i =>
                                    i === 1 ||
                                    i === totalPages ||
                                    (i >= page - 1 && i <= page + 1)
                                )
                                .map(i => (
                                    <button
                                        key={i}
                                        className={`pmndp-pagination-btn ${page === i ? 'active' : ''}`}
                                        onClick={() => handlePageChange(i)}
                                        disabled={page === i || isLoading}
                                    >
                                        {i}
                                    </button>
                                ))}
                            
                            <button
                                className="pmndp-pagination-btn"
                                onClick={() => handlePageChange(page + 1)}
                                disabled={page === totalPages || totalPages === 0 || isLoading}
                                title={DIALYSIS_LABELS.next}
                            >
                                &#8250;
                            </button>
                            <button
                                className="pmndp-pagination-btn"
                                onClick={() => handlePageChange(totalPages)}
                                disabled={page === totalPages || totalPages === 0 || isLoading}
                                title={DIALYSIS_LABELS.last}
                            >
                                &#187;
                            </button>
                            
                            <span className="pmndp-pagination-info">
                                {DIALYSIS_LABELS.page} {page} {DIALYSIS_LABELS.of} {totalPages}
                            </span>
                        </div>
                    )}
                </div>
            </div>
             ) : (
      <PeritonealDialysisModule />
    )}

            {bookAnAppointmentModel && (
                <BookAnAppointment
                    onClose={() => setBookAnAppointmentModel(false)}
                    patient_name={bookAnAppointmentModel.patient_name}
                    patient_id={bookAnAppointmentModel.patient_id}
                    abha_number={bookAnAppointmentModel.abha_number}
                    getDiaList={() => getDiaList(page, searchFields)}
                />
            )}

            {startDialysis && (
                <StartDialysis onClose={() => setStartDialysis(false)}
                    patient_name={startDialysis.patient_name}
                    patient_id={startDialysis.patient_id}
                    dialysis_id={startDialysis.dialysis_id}
                    abha_number={startDialysis.abha_number}
                    abha_address={startDialysis.abha_address}
                    age={startDialysis.age}
                    gender={startDialysis.gender}
                    mobile={startDialysis.mobile}
                    getDiaList={() => getDiaList(page, searchFields)}
                />
            )}

            {completeDialysis && (
                <CompleteDialysis onClose={() => setCompleteDialysis(false)}
                    patient_name={completeDialysis.patient_name}
                    patient_id={completeDialysis.patient_id}
                    last_dialysis={completeDialysis.last_dialysis}
                    dialysis_id={completeDialysis.dialysis_id}
                    abha_number={completeDialysis.abha_number}
                    abha_address={completeDialysis.abha_address}
                    age={completeDialysis.age}
                    gender={completeDialysis.gender}
                    mobile={completeDialysis.mobile}
                    getDiaList={() => getDiaList(page, searchFields)}
                />
            )}

            {unbook && (
                <UnbookAppointment onClose={() => setUnbook(false)}
                    patient_id={unbook.patient_id}
                    dialysis_id={unbook.dialysis_id}
                    slot_id={unbook.slot_id}
                    getDiaList={() => getDiaList(page, searchFields)}
                />
            )}

            <div className="pmndp-footer">
                <p>
                    © All rights reserved by Ministry of Health & Family Welfare,
                    Government of India.
                </p>
            </div>
        </div>
    )
}
